// extracted by mini-css-extract-plugin
export var backdropBlur = "_lh-0";
export var contentCard = "_lh-5";
export var frame = "_lh-2";
export var image = "_lh-4";
export var imagePane = "_lh-3";
export var modal = "_lh-1";